import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
     Container, Row, Col,
     Label, Input, InputGroup, CardLink,
     Card, CardImg, CardText, CardBody,
     CardTitle, CardSubtitle, Button, Badge,
     FormFeedback, Modal, ModalHeader, ModalBody, ModalFooter,
     UncontrolledTooltip,
} from 'reactstrap';

import ParadigmaTable from "../../../../components/ParadigmaTable/";
import ParadigmaAsyncSeeker from '../../../../components/ParadigmaAsyncSeeker/ParadigmaAsyncSeeker';
import ParadigmaLabeledInput from '../../../../components/ParadigmaLabeledInput/ParadigmaLabeledInput';
import apifunctions from '../../../../api/functions.js';
import FormatFunctions from "../../../../functions/functions";
import api from '../../../../api/';

import Tilde from './Tilde.js';


class ArticulosDestacadosModalTable extends Component {
     constructor() {
          super();
          this.refTable = React.createRef();
          this.state = {
               columns: [
                    {
                         Header: "id",
                         id: "id",
                         accessor: "id",
                         show: false,
                         private: true,
                    },
                    {
                         Header: "Categoria_id",
                         id: "Categoria_id",
                         accessor: "Categoria_id",
                         show: false,
                         lookup:"exact",
                         private: true,
                    },
                    {
                         Header: "Codigo",
                         id: "Codigo",
                         accessor: "Codigo",
                         show: true,
                         style:{textAlign:"center"},
                         filterable: true,
                         width: 75,
                    },
                    {
                         Header: "Categoria",
                         id: "categoria_nombre",
                         accessor: "categoria_nombre",
                         show: true,
                         filterable: true,
                    },
                    {
                         Header: "Titulo",
                         id: "Titulo",
                         accessor: "Titulo",
                         show: true,
                         filterable: true,
                    },
                    {
                         Header: "Stock",
                         id: "maxQuantity",
                         accessor: "maxQuantity",
                         show: true,
                         className:"text-center",
                         width:100,
                         filterable: true,
                    },
                    {
                         Header: "Destacado",
                         className: "text-center",
                         id:"code",
                         Cell: d=>{
                              const id = d.original.id;
                              const state = this.props.articulos.filter(elem_id=>id == elem_id).length > 0;
                              return (
                                   <Tilde disabled={this.props.disabled} valueChanged={(val1, val2)=> this.props.ArticulosDestacadosChanged(val1, val2)} checked={state} id={id}/>
                              );
                         },
                         filterable: false,
                         sortable:true,
                         lookup:"exact",
                         Filter: ({ filter, onChange }) =>(
                              <select
                              onChange={event => onChange(event.target.value)}
                              style={{ width: "100%" }}
                              value={filter ? filter.value : "TODOS"}>
                              <option value="">TODOS</option>
                              <option value={"True"}>SI</option>
                              <option value={"False"}>NO</option>
                              </select>
                         ),
                         width: 150,
                         show: true,
                    },
               ],
               categoria_id:null,
          };
     }

     static propTypes = {
          additionalFields: PropTypes.arrayOf(PropTypes.shape({
               name: PropTypes.string.isRequired,
               onGet: PropTypes.string.isRequired, // (data: data que llega del servidor) => objeto: { key: value } lo que retorna se setea en el estado
               onPost : PropTypes.string.isRequired, // (data: data del estado que se envia al servidor) => objeto: { key: value } lo que se envia al servidor
               Input: PropTypes.func.isRequired, // (state, setThis, disabled, error) => <Input />
          })),
     }

     render() {
          const MarcarTodos = () => {
               const MarcarTodosOnClick = () => {
                    const filters = ["paginationEnabled=False"];
                    if (this.state.categoria_id != undefined && this.state.categoria_id != null){
                         filters.push("Categoria_id[exact]="+this.state.categoria_id);
                    }

                    apifunctions.get(
                         api.gestion.articulos.destacados.articulos, null, null, {filters:filters},
                         (data)=>{
                              let articulos = [];
                              this.props.articulos.forEach(id => {
                                   if(articulos.filter(item=>item == id).length == 0) articulos.push(id);
                              });
                              data.data.map(item=>item.id).forEach(id => {
                                   if(articulos.filter(item=>item == id).length == 0) articulos.push(id);
                              });
                              articulos.sort((a, b) => (a-b));
                              this.props.ChangeAllDataSet(articulos);
                         },
                    );
               };
               return(
                    <div>
                    <button onClick={MarcarTodosOnClick} id="SelectAll" className="icon btn btn-sm h-100 btn-info"><i class="fa fa-check-circle fa-lg" aria-hidden="true"></i></button>
                    <UncontrolledTooltip placement="bottom" target="SelectAll">
                    Marcar Todos
                    </UncontrolledTooltip>
                    </div>
               );
          };

          const DesmarcarTodos = () => {
               const DesmarcarTodosOnClick = () => {
                    const filters = ["paginationEnabled=False"];
                    if (this.state.categoria_id != undefined && this.state.categoria_id != null){
                         filters.push("Categoria_id[exact]="+this.state.categoria_id);
                    }

                    apifunctions.get(
                         api.gestion.articulos.destacados.articulos, null, null, {filters:filters},
                         (data)=>{
                              let articulos = [];
                              let idsToAvoid = data.data.map(item=>item.id);
                              this.props.articulos.forEach(id => {
                                   if(idsToAvoid.filter(item=>item == id).length == 0) articulos.push(id);
                              });
                              articulos.sort((a, b) => (a-b));
                              this.props.ChangeAllDataSet(articulos);
                         },
                    );
               };
               return(
                    <div>
                    <button onClick={DesmarcarTodosOnClick} id="UnselectAll" className="icon btn btn-sm h-100 btn-danger"><i class="fa fa-times fa-lg" aria-hidden="true"></i></button>
                    <UncontrolledTooltip placement="bottom" target="UnselectAll">
                    Desmarcar Todos
                    </UncontrolledTooltip>
                    </div>
               );
          };

          const { data, pages, loading, categoria_id } = this.state;
          const { additionalFields, modernTheme } = this.props;
          const outerFilter = [];
          if (categoria_id != undefined && categoria_id != null) {
               outerFilter.push({
                    id: 'Categoria_id',
                    lookup:'exact',
                    value: categoria_id
               });
          }
          const buttons = [];
          if (this.props.disabled == false){
               [
                    {
                         detail: true,
                         component: () => <MarcarTodos />,
                    },
                    {
                         detail: true,
                         component: (props) => <DesmarcarTodos />,
                    },
               ].forEach((item, i) => {
                    buttons.push(item);
               });

          }

          return (
               <Container className="p-0">
               <Row className="mb-2">
               <Col className="col-12">
               <Card body className="border-0 p-0 m-0">
               <CardTitle className="text-center py-2 mb-0 col-color">Filtros</CardTitle>
               <CardBody>
               <Row>
               <Col className="col-12">
               <ParadigmaLabeledInput
               label="Categoria"
               md={[3, 9]}
               inputComponent={
                    <ParadigmaAsyncSeeker
                    url={api.gestion.articulos.categorias}
                    value={this.state.categoria_id}
                    displayField="fullName"
                    parameters={{
                         paginationEnabled:false,
                    }}
                    onChange={data => this.setState({categoria_id:data?data.id : null})}
                    />
               }
               />
               </Col>
               </Row>
               </CardBody>
               </Card>
               </Col>
               </Row>
               <ParadigmaTable
               modernTheme={modernTheme}
               buttons={buttons}
               apiUrl={api.gestion.articulos.destacados.articulos}
               columns={this.state.columns}
               title={"Artículos Destacados"}
               defaultPageSize={10}
               ref={this.refTable}
               innerRef={this.refTable}
               outerFilter={[...outerFilter,]}
               />
               </Container>
          );
     }
}

export default ArticulosDestacadosModalTable;



// WEBPACK FOOTER //
// ./src/views/Gestion/Articulos/Destacados/ArticulosDestacadosModalTable.js